import Select, { components } from "react-select";
import Button from "../../components/button/Button";
import Reset from "../../assets/images/reset.svg";
import {useState, useRef, useEffect} from "react";
import styles from "./productListFilter.module.scss";
import {useSelector} from "react-redux";
import {selectPredefinedFilterValues} from "./productListSlice";
import ReactDOM from "react-dom";

const ProductListFilter = ({ setFilter, onResetSort }) => {
  const preDefinedFilterValues = useSelector(selectPredefinedFilterValues)
  const defaultFilterState = {
    Category: [],
    SubCategory: [],
    SdAvailable: [],
    BtEnabled: [],
    ControlId: [],
    ControlType: [],
    State: [],
    Recipe: [],
  };

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSubCategories, setSelectedSubCategories] = useState([]);
  const [availableCategories, setAvailableCategories] = useState([...preDefinedFilterValues.Category]);
  const [availableSubCategories, setAvailableSubCategories] = useState([...preDefinedFilterValues.SubCategory]);
  const [dataFilter, setDataFilter] = useState(defaultFilterState);

  useEffect(() => {
    if (selectedCategories.length === 0) {
      setAvailableSubCategories([...preDefinedFilterValues.SubCategory])
      return;
    }
    const updatedSubCategories = new Set();
    selectedCategories.forEach(c => {
      for (let i = 0; i < preDefinedFilterValues.CategorySubcategories.length; i++) {
        const {category, subcategories} = preDefinedFilterValues.CategorySubcategories[i];
        if (category === c) {
          subcategories.forEach(subcategory => updatedSubCategories.add(subcategory))
        }
      }
    })
    setAvailableSubCategories([...updatedSubCategories]);
  }, [selectedCategories]);

  useEffect(() => {
    if (selectedCategories.length !== 0) {
      return;
    }
    if (selectedSubCategories.length === 0) {
      setAvailableCategories([...preDefinedFilterValues.Category])
      // Clear selected categories if all subcategories are unselected
      setSelectedCategories([]);
      setDataFilter(prevState => ({
        ...prevState,
        Category: [],
      }));
      return;
    }
    const updatedCategories = new Set();
    selectedSubCategories.forEach(s => {
      for (let i = 0; i < preDefinedFilterValues.CategorySubcategories.length; i++) {
        const {category, subcategories} = preDefinedFilterValues.CategorySubcategories[i];
        if (subcategories.indexOf(s) !== -1) {
          updatedCategories.add(category)
        }
      }
    })
    setAvailableCategories([...updatedCategories]);
    setDataFilter(prevState => ({
      ...prevState,
      Category: [...updatedCategories].map(key => ({
        value: key,
        label: key
      })),
    }))
  }, [selectedSubCategories]);

  const productCategoryOptions = Array.from(new Set(availableCategories)).map(item => {
  let label = item;

  try {
    const parsed = JSON.parse(item);

    label = Object.entries(parsed)
      .map(([key, value]) => `${key}: ${value}`)
      .join(", ");
  } catch (e) {
    label = item;
  }

  return {
    value: item,
    label
  };
});

  const productSubCategoryOptions = Array.from(new Set(availableSubCategories)).map(key => ({
    value: key,
    label: key
  }))

  const sharedDataOptions = [
    { value: true, label: "Available" },
    { value: false, label: "Not Available" },
  ];

  const bluetoothEnabledOptions = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];

  const controlIDOptions = Array.from(new Set(preDefinedFilterValues.ControlId)).map(key => ({
    value: key,
    label: key
  }));

  const controlTypeOptions = Array.from(new Set(preDefinedFilterValues.ControlType)).map(key => ({
    value: key,
    label: key
  }));

  const stateOptions = [
    { value: "Staging", label: "Staging" },
    { value: "Pre_Prod", label: "Pre_Prod" },
    { value: "Production", label: "Production" },
  ];
const recipeOptions = preDefinedFilterValues.Recipe 
  ? Array.from(new Set(preDefinedFilterValues.Recipe)).map(key => ({
      value: key,
      label: key
    }))
  : [];
  const MAX_VISIBLE_CHIPS = 1;

const MultiValue = (props) => {
  const { index, getValue, selectProps } = props;
  const values = getValue();
  const [showPopover, setShowPopover] = useState(false);
  const chipRef = useRef(null);
  const [popoverPos, setPopoverPos] = useState({ top: 0, left: 0 });

  // Handler to remove a value
  const handleRemove = (value) => {
    const newValue = values.filter((v) => v.value !== value.value);
    selectProps.onChange(newValue, { action: 'remove-value', removedValue: value });
  };

  // Calculate popover position and flip if near viewport edge
  const handleMouseEnter = () => {
    if (chipRef.current) {
      const rect = chipRef.current.getBoundingClientRect();
      const offset = 6;
      let top = rect.bottom + window.scrollY + offset;
      if (top + 180 > window.innerHeight) {
        top = rect.top + window.scrollY - 180 - offset;
      }
      setPopoverPos({ top, left: rect.left + window.scrollX });
    }
    setShowPopover(true);
  };

  if (index < MAX_VISIBLE_CHIPS) {
    return (
      <components.MultiValue {...props} />
    );
  }
  if (index === MAX_VISIBLE_CHIPS) {
    return (
      <>
        <div
          ref={chipRef}
          className={styles.moreChips}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={() => setShowPopover(false)}
          style={{ position: 'relative', display: 'inline-block', cursor: 'pointer' }}
        >
          +{values.length - MAX_VISIBLE_CHIPS}
        </div>
        {showPopover && ReactDOM.createPortal(
          <div
            className={styles.popover}
            style={{
              top: popoverPos.top,
              left: popoverPos.left,
              position: 'absolute'
            }}
            onMouseEnter={() => setShowPopover(true)}
            onMouseLeave={() => setShowPopover(false)}
          >
            {values.map((v) => (
              <div key={v.value} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                <span style={{ flex: 1 }}>{v.label}</span>
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#d00',
                    cursor: 'pointer',
                    fontSize: '16px',
                    marginLeft: 8
                  }}
                  onClick={() => handleRemove(v)}
                  aria-label={`Remove ${v.label}`}
                  tabIndex={-1}
                >
                  ×
                </button>
              </div>
            ))}
          </div>,
          document.body
        )}
      </>
    );
  }
  return null;
};

  const customStyles = {
    option: (defaultStyles, state) => ({
      ...defaultStyles,
      color: state.isSelected ? "red" : "#fff",
      backgroundColor: state.isSelected ? "#fff" : "#fff",
    }),

    indicatorSeparator: (defaultStyles, state) => ({
      ...defaultStyles,
      width: 0,
    }),

    valueContainer: (defaultStyles) => ({
      ...defaultStyles,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      flexWrap: 'nowrap',
    }),

    indicatorsContainer: (defaultStyles) => ({
      ...defaultStyles,
      whiteSpace: 'nowrap',
    }),

    control: (defaultStyles) => ({
      ...defaultStyles,
      overflow: "hidden",
      width: "100%",
      height: "40px",
      borderRadius: "8px",
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'nowrap',
      boxSizing: 'border-box',
    }),
  };
  const filterDropdown = [
    {
    label: "Product category",
    options: productCategoryOptions,
    name: "Category",
    },
    {
      label: "Product sub category",
      options: productSubCategoryOptions,
      name: "SubCategory",
    },
    { label: "Shared data", options: sharedDataOptions, name: "SdAvailable" },
    {
      label: "Bluetooth enabled",
      options: bluetoothEnabledOptions,
      name: "BtEnabled",
    },
    { label: "Control ID", options: controlIDOptions, name: "ControlId" },
    { label: "Control type", options: controlTypeOptions, name: "ControlType" },
    { label: "State", options: stateOptions, name: "State" },
    { label: "Recipe", options: recipeOptions, name: "Recipe" },

  ];

  const selectView = (item) => {
    return (
    <div className={styles.filter_item}>
      <label>{item.label}</label>
      <Select
        placeholder="Select"
        options={item.options}
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{ Option, MultiValue }}
        isClearable={true}
        isSearchable={true}
        menuPortalTarget={document.body}
        menuPosition={"fixed"}
        styles={customStyles}
        onChange={(e) => onChangeDataHandler(e, item.name)}
        value={dataFilter[item.name]}
      />
    </div>
  );
  };
  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const onChangeDataHandler = (e, field) => {
    setDataFilter((prev) => {
      return {
        ...prev,
        [field]: e,
      }
    });
    if (field === "Category") {
      setSelectedCategories(e.map(i => i.value))
    }
    if (field === "SubCategory") {
      setSelectedSubCategories(e.map(i => i.value))
    }
  };

  const onClear = () => {
    setDataFilter(defaultFilterState);
    setFilter(defaultFilterState);
    setAvailableCategories([...preDefinedFilterValues.Category]);
    setAvailableSubCategories([...preDefinedFilterValues.SubCategory]);
    setSelectedCategories([]);
    setSelectedSubCategories([]);
    if (onResetSort) onResetSort();
  };

  return (
    <div className={styles.container}>
      <div className={styles.filter_row}>
      {filterDropdown.map((item) => selectView(item))}
      </div>
      <div className={styles.filterButtons}>
        <Button style={styles.reset} onClick={onClear}>
          <img src={Reset} alt="reset-icon" className={styles.resetIcon} />
          Reset All
        </Button>
        <Button style={styles.done} onClick={() => {
          setFilter(dataFilter);
          if (onResetSort) onResetSort();
        }}>
          Done
        </Button>
      </div>
    </div>
  );
};

export default ProductListFilter;
